import { Injectable } from '@angular/core'

export const CustomBreakpointNames = {
  extraSmall: 'extraSmall',
  small: 'small',
  medium: 'medium',
  large: 'large',
  extraLarge: 'extraLarge',

}

@Injectable({
  providedIn: 'root'
})
export class BreakpointsService {
  constructor() { }

breakpoints: object = {
  '(min-width: 320px)': CustomBreakpointNames.extraSmall,
  '(max-width:767px)': CustomBreakpointNames.extraSmall,
  '(min-width: 576px)': CustomBreakpointNames.small,
  '(max-width: 767px)': CustomBreakpointNames.small,
  '(min-width: 768px)': CustomBreakpointNames.medium,
  '(max-width: 991px)': CustomBreakpointNames.medium,
  '(min-width: 992px)': CustomBreakpointNames.large,
  '(min-width: 1199px)': CustomBreakpointNames.large,
  '(min-width: 1200px)': CustomBreakpointNames.extraLarge,
  '(max-width: 5000px)': CustomBreakpointNames.extraLarge
}
  getBreakpoints(): string[] {
    return Object.keys(this.breakpoints)
  }

  getBreakpointName(breakpointValue): string {
    return this.breakpoints[breakpointValue]
  }
}
